import { useBeforeUnload } from "react-router";

/**
 * Block external navigation if any save guard is enabled.
 *
 * This functionality is only extracted for readability. Do NOT reuse this hook.
 */
function useExternalNavigationBlocker(saveGuardEnabledIds: Set<string>) {
  /**
   * Before the document unloads and any save guard is enabled, prevent the event.
   * This will show a native browser prompt where the user can choose to proceed
   * or abort unloading the document.
   */
  useBeforeUnload((e) => {
    if (saveGuardEnabledIds.size > 0) {
      e.preventDefault();
    }
  });
}

export default useExternalNavigationBlocker;
